import { HttpInterceptorFn } from '@angular/common/http';
import { authInterceptor } from './auth.interceptor';
import { globalErrorHandlerInterceptor } from '../api/global-error-handler.interceptor';

/**
 * Production/UAT HTTP interceptor chain.
 *
 * @remarks
 * Build-time replacement for {@link ./http-interceptors.ts}, wired via
 * `fileReplacements` in `angular.json` for the `production` and `uat`
 * build configurations. Deliberately has no import of `mock.interceptor.ts`
 * (and transitively `mock-data.ts`) so those modules are never parsed or
 * bundled into production/UAT output, rather than relying on tree-shaking
 * of an unreachable `environment.mock` branch.
 */
export const HTTP_INTERCEPTORS: HttpInterceptorFn[] = [authInterceptor, globalErrorHandlerInterceptor];
